/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./skin-list.vue?vue&type=template&id=37fa09ea&scoped=true&"
import script from "./skin-list.vue?vue&type=script&lang=ts&"
export * from "./skin-list.vue?vue&type=script&lang=ts&"
import style0 from "./skin-list.vue?vue&type=style&index=0&id=37fa09ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fa09ea",
  null
  
)

export default component.exports